import React, { forwardRef, useEffect, useState } from "react";

const ServicePoPrint = forwardRef((props, ref) => {
  const [data, setData] = useState([]);
  useEffect(() => {
    setData(props?.data);
  }, [props]);

  const styles = {
    container: { fontFamily: "Arial", fontSize: "14px", margin: "20px" },
    h2: { textAlign: "center", textTransform: "uppercase", margin: "5px 0" },
    table: { width: "100%", borderCollapse: "collapse", marginBottom: "10px" },
    th: {
      border: "1px solid #000",
      padding: "4px",
      textAlign: "left",
      backgroundColor: "#f2f2f2",
    },
    td: { border: "1px solid #000", padding: "4px", textAlign: "left" },
    sectionTitle: {
      backgroundColor: "#ddd",
      fontWeight: "bold",
      padding: "4px",
      margin: "10px 0",
    },
    textRight: { textAlign: "right" },
    textCenter: { textAlign: "center" },
    noBorder: { border: "none" },
  };

  const printbody = {
    display: "flex",
    flexDirection: "column",
    margin: "10px",
  };

  const totals = (data?.items || []).reduce(
    (acc, item) => {
      acc.purchaseQuantity += Number(item.purchaseQuantity);
      acc.orderPriceUnit += Number(item.orderPriceUnit);
      acc.netValue += Number(item.netValue);
      acc.taxAmount += Number(item.taxAmount);
      return acc;
    },
    { purchaseQuantity: 0, orderPriceUnit: 0, netValue: 0, taxAmount: 0 }
  );

  return (
    <div ref={ref} style={printbody} className="m-4">
      <div style={styles.container}>
        <h2 style={styles.h2}>Service PO</h2>

        <div style={styles.sectionTitle}>Invoice & Vendor Details</div>
        <table style={styles.table}>
          <tbody>
            <tr>
              <td style={styles.td}>
                <strong>Invoice No:</strong> {data.purchasingDocumentNr}
              </td>
              <td style={styles.td}>
                <strong>Date:</strong> {data.purchasingDocumentDate}
              </td>
            </tr>
            <tr>
              <td style={styles.td}>
                <strong>Vendor:</strong> {data.vendorName} ({data.vendorCode})
              </td>
              <td style={styles.td}>
                <strong>Company:</strong> {data.companyCode}
              </td>
            </tr>
            <tr>
              <td style={styles.td}>
                <strong>Payment Terms:</strong> {data.paymentTerms}
              </td>
              <td style={styles.td}>
                <strong>Inco Terms:</strong> {data.incoTerms}
              </td>
            </tr>
          </tbody>
        </table>

        <div style={styles.sectionTitle}>Line Items</div>
        { data.items && data?.items.map((item, idx) => (
          <div key={idx} style={{ marginBottom: "15px" }}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>#</th>
                  <th style={styles.th}>Material Code</th>
                  <th style={styles.th}>Description</th>
                  <th style={styles.th}>Quantity</th>
                  <th style={styles.th}>Unit</th>
                  <th style={styles.th}>Unit Price</th>
                  <th style={styles.th}>Net Value</th>
                  <th style={styles.th}>Tax</th>
                  <th style={styles.th}>Delivery Date</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={styles.td}>{idx + 1}</td>
                  <td style={styles.td}>{item.materialCode}</td>
                  <td style={styles.td}>{item.materialDescription}</td>
                  <td style={{ ...styles.td, textAlign: "right" }}>
                    {item.purchaseQuantity}
                  </td>
                  <td style={styles.td}>{item.orderUnitOfMeasure}</td>
                  <td style={{ ...styles.td, textAlign: "right" }}>
                    {item.orderPriceUnit}
                  </td>
                  <td style={{ ...styles.td, textAlign: "right" }}>
                    {item.netValue}
                  </td>
                  <td style={{ ...styles.td, textAlign: "right" }}>
                    {item.taxAmount}
                  </td>
                  <td style={styles.td}>{item.deliveryDate}</td>
                </tr>
              </tbody>
            </table>

            {item.services && (
              <>
                <div style={styles.sectionTitle}>Services</div>
                <table style={styles.table}>
                  <thead>
                    <tr>
                      <th style={styles.th}>Service Line</th>
                      <th style={styles.th}>Service Code</th>
                      <th style={styles.th}>Description</th>
                      <th style={styles.th}>Quantity</th>
                      <th style={styles.th}>Unit</th>
                      <th style={styles.th}>Unit Price</th>
                      <th style={styles.th}>Gross Value</th>
                      <th style={styles.th}>Delivery Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {item.services.map((srv, sidx) => (
                      <tr key={sidx}>
                        <td style={styles.td}>{srv.serviceLineNr}</td>
                        <td style={styles.td}>{srv.serviceNr}</td>
                        <td style={styles.td}>{srv.serviceDescription}</td>
                        <td style={{ ...styles.td, textAlign: "right" }}>
                          {srv.serviceQuantity}
                        </td>
                        <td style={styles.td}>{srv.orderUnitOfMeasure}</td>
                        <td style={{ ...styles.td, textAlign: "right" }}>
                          {srv.unitValue}
                        </td>
                        <td style={{ ...styles.td, textAlign: "right" }}>
                          {srv.grossValue}
                        </td>
                        <td style={styles.td}>{srv.deliveryDate}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}
          </div>
        ))}

        <div style={styles.sectionTitle}>Summary</div>
        <table style={styles.table}>
          <tbody>
            <tr>
              <td style={styles.td}>
                <strong>Total Quantity:</strong>
              </td>
              <td style={styles.td}>{totals.purchaseQuantity}</td>
            </tr>
            <tr>
              <td style={styles.td}>
                <strong>Total Order Price:</strong>
              </td>
              <td style={styles.td}>{totals.orderPriceUnit}</td>
            </tr>
            <tr>
              <td style={styles.td}>
                <strong>Total Net Value:</strong>
              </td>
              <td style={styles.td}>{totals.netValue}</td>
            </tr>
            <tr>
              <td style={styles.td}>
                <strong>Total Tax:</strong>
              </td>
              <td style={styles.td}>{totals.taxAmount}</td>
            </tr>
            <tr>
              <td style={styles.td}>
                <strong>Grand Total:</strong>
              </td>
              <td style={styles.td}>{data.purchasingDocumentValue}</td>
            </tr>
          </tbody>
        </table>

        <div style={styles.sectionTitle}>Remarks</div>
        <p>{data.purchasingRemark || "N/A"}</p>

        <div style={{ ...styles.textRight, marginTop: "30px" }}>
          <p>
            For <strong>{data.vendorName}</strong>
          </p>
          <p>
            <br />
            <br />
            Authorised Signatory
          </p>
        </div>
      </div>
    </div>
  );
});

export default ServicePoPrint;
